var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 188,
    viewBox: "0 0 199 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 188
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard \\u2013 2",
    clipPath: "url(#clip-Artboard_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(12.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M170.58,146.811,144.99,143l-22.323,5.989-5.445,34.846-2.722,35.39h22.323l6.534-34.3,8.167,34.3h24.5c-.726-7.622-2.178-23.085-2.178-23.956,0-1.089.544-6.534.544-14.156s-1.089-11.434-1.633-19.056A125.743,125.743,0,0,0,170.58,146.811Z",
    transform: "translate(-6.892 -31.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M116.7,180.045l.544-3.267c-.182-.363-.653-.98-1.089-.544s-1.633-.182-2.178-.544v-5.445c0-1.307,3.629-6.715,5.445-9.256L110.716,155c-.907,2-3.049,6.642-4.356,9.256A64.655,64.655,0,0,0,102,176.234c-.436,2.178,2,4.9,3.267,5.445v2.178c0,1.089,0,2.722.544,3.267.436.436,1.633-.907,2.178-1.633,0-.182-.327-.544.544-.544,1.089,0,1.633,1.089,5.989,0a15.951,15.951,0,0,0,4.9-2.178Z",
    transform: "translate(-8.007 -30.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M140.394,85.39,85.323,48.271,25.63,77.377,21,143.6l55.071,37.119,59.694-29.106Z",
    transform: "translate(-15.206 -39.648)",
    fill: "#fe5f22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M92.239,105.066l45.75,20.36s-6.666,5.654-9.661,6.725-2.138,7.057-2.138,7.057l-1.774,21.031-.849.578-4.506,7.512-8.426-5.206s6.119-13.5,7.137-18.741,2.655-11.036,2.655-11.036l.324-1.272-.378-.764s-6.343-3.177-9.585-7.049S94.94,110.826,94.94,110.826a7.8,7.8,0,0,1-5.309.34c-3.11-.825-3.349-1.1-3.349-1.1L83.2,105.512l4.676-.446Z",
    transform: "translate(-9.675 -34.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M124.6,92.317l-7.083,23.306,6.126,2.507Z",
    transform: "translate(-6.624 -35.732)",
    fill: "#4f85e2",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M121.039,152.771l-3.242,2.175,2.887-27.2,2.013.733Z",
    transform: "translate(-6.598 -32.581)",
    fill: "#4f85e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M118.968,49.007c-2.121,1.8-3.233,11.553-3.264,13.975s-2.107,11.06-2.346,15.2c0,0-1.474,8.7,1.211,15.016s9.383,7.1,13.281,6.016,3.171-8.7,3.171-8.7l-.933-5.584c1.443-.494,2.423-.979,2.461-1.242,1.18-8.36-11.451-36.487-13.573-34.682Z",
    transform: "translate(-7.029 -39.59)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M128.235,63.739l.323,30.279,17.709-1.643L136.53,63.647Z",
    transform: "translate(-5.67 -38.281)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M116.205,53.112s-1.937,20.962,6.319,24.417,15.679-10.8,16.9-16.929.147-16.427-9.854-17.129-13.364,9.648-13.364,9.648Z",
    transform: "translate(-6.758 -40.078)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M126.118,69.64a3.814,3.814,0,0,1-3.048,1.643,4.973,4.973,0,0,1-3.14-2.005s3.858-.794,6.181.363Z",
    transform: "translate(-6.409 -37.804)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M119.937,69.334a3.816,3.816,0,0,1,3.048-1.643,4.973,4.973,0,0,1,3.14,2.005s-3.858.794-6.181-.363Z",
    transform: "translate(-6.408 -37.922)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M123.495,61.239a4.537,4.537,0,0,1,3.04-1.882,4.413,4.413,0,0,1,3.434,1.172,3.706,3.706,0,0,1-3.418,1.851c-2.339-.177-3.064-1.134-3.064-1.134Z",
    transform: "translate(-6.092 -38.665)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M122.623,61.672s1.265-2.506,3.58-2.684A9.747,9.747,0,0,1,131,60.26l-.478.5s-3.241-2-4.946-.987S123.248,61.633,122.623,61.672Z",
    transform: "translate(-6.169 -38.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M120.432,61.34a4.564,4.564,0,0,0-3.079-1.82,4.418,4.418,0,0,0-3.411,1.242,3.708,3.708,0,0,0,3.457,1.774c2.338-.224,3.033-1.2,3.033-1.2Z",
    transform: "translate(-6.941 -38.65)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M121.076,61.574s-1.235-2.321-3.41-2.445a9.062,9.062,0,0,0-4.468,1.288l.455.463s2.995-1.936,4.615-1.018,2.215,1.7,2.808,1.72Z",
    transform: "translate(-7.007 -38.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M119.455,68.881s.37.74,3.348.979,4.29-.555,4.29-.555",
    transform: "translate(-6.451 -37.816)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M123.622,56.192s.015,1.357.595,1.488,3.2-.9,4.853-.524a4,4,0,0,1,2.068.879s-.61-2.653-3.033-2.823A8.958,8.958,0,0,0,123.622,56.192Z",
    transform: "translate(-6.08 -39.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M120.527,56.441s.008,1.357-.563,1.5-3.225-.833-4.862-.416a4.159,4.159,0,0,0-2.053.918s.556-2.669,2.971-2.892a8.945,8.945,0,0,1,4.5.879Z",
    transform: "translate(-7.021 -39.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M122.919,47.179a10.573,10.573,0,0,1-2.677,4.026c-1.79,1.519-4.1,3.756-4.1,3.756s-1.05-5.483,2.183-8.908,6.328-3.887,8.635-3.378S122.919,47.179,122.919,47.179Z",
    transform: "translate(-6.76 -40.161)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M122.354,46.8s.354,6.687,5.4,8.5,7.238,1.427,7.238,1.427",
    transform: "translate(-6.193 -39.779)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M128.349,74.794a21.5,21.5,0,0,0,4.02-3.8c3.241-5.067,4.252-6.771,4.252-6.771s.115,3.517-4.09,10.558c-1.211,2.036-4.275,3.625-4.275,3.625l.093-3.6Z",
    transform: "translate(-5.668 -38.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M116.846,65.786a6.184,6.184,0,0,0-1.288,3.44c.008,1.843,1.358,4.1,3.286,2.653,0,0-.9-2.09-1.18-3.124-.255-.91-.633-2.082-.81-2.969Z",
    transform: "translate(-6.797 -38.091)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M120.16,161.561l-2.136-1.457s-3.372-3.7,14.49-4.489,38.582.694,38.582.694-2.971-24.494-8.141-48.858-17.47-27.394-17.47-27.394-5.331,6.008-10.108,7.743-6.119-2.468-6.119-2.468-9.622,10-6.775,29.977",
    transform: "translate(-6.601 -36.822)",
    fill: "#4f85e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M120.16,161.561l-2.136-1.457s-3.372-3.7,14.49-4.489,38.582.694,38.582.694-2.971-24.494-8.141-48.858-17.47-27.394-17.47-27.394-5.331,6.008-10.108,7.743-6.119-2.468-6.119-2.468-9.622,10-6.775,29.977",
    transform: "translate(-6.601 -36.822)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M119.314,130.021c-.023-.154.9-11.329.9-11.329l14.569,5.53s-6.312,6.124-10.34,6.972-4.915.363-5.131-1.164Z",
    transform: "translate(-6.463 -33.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M83.139,106.229a1.992,1.992,0,0,1-1.42-2.545,21.555,21.555,0,0,1-2.77-.039c-1.836-.115-3.634-.6-3.7-1.088s.262-1.156,1.273-1.349a65.476,65.476,0,0,1,10.9-1.535c5.054-.185,8.01-.077,15.95,2.661s19.915,10.705,20.9,11.3a1.555,1.555,0,0,0,2.022,0c.525-.378,5.918-8.083,5.918-8.083a40.671,40.671,0,0,1,11,20.022c2.808,12.687-5.193.971-5.193.971",
    transform: "translate(-10.383 -35.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M83.139,106.229a1.992,1.992,0,0,1-1.42-2.545,21.555,21.555,0,0,1-2.77-.039c-1.836-.115-3.634-.6-3.7-1.088s.262-1.156,1.273-1.349a65.476,65.476,0,0,1,10.9-1.535c5.054-.185,8.01-.077,15.95,2.661s19.915,10.705,20.9,11.3a1.555,1.555,0,0,0,2.022,0c.525-.378,5.918-8.083,5.918-8.083a40.671,40.671,0,0,1,11,20.022c2.808,12.687-5.193.971-5.193.971",
    transform: "translate(-10.383 -35.083)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M141.166,121.46s-11.081,11.977-17.146,10.851-10.711-5.761-17-11.6a148.445,148.445,0,0,0-12.508-10.327s-3.6,1.681-6.52-.262",
    transform: "translate(-9.249 -34.148)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M85.944,103.9s-3.333.448-3.441,1.944.224,2.059.826,2.583",
    transform: "translate(-9.739 -34.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M85.944,103.9s-3.333.448-3.441,1.944.224,2.059.826,2.583",
    transform: "translate(-9.739 -34.702)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M86.683,105.979s-4.19.54-3.148,3.2,4.306,2.244,4.607,1.983.71-.9-1.2-2.283",
    transform: "translate(-9.66 -34.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M86.683,105.979s-4.19.54-3.148,3.2,4.306,2.244,4.607,1.983.71-.9-1.2-2.283",
    transform: "translate(-9.66 -34.517)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M82.425,102.969l-1.235.417",
    transform: "translate(-9.854 -34.784)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M120.345,130.293s-2.1,20.461-2.555,24.426Z",
    transform: "translate(-6.599 -32.355)",
    fill: "#4f85e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M120.345,130.293s-2.1,20.461-2.555,24.426",
    transform: "translate(-6.599 -32.355)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M137.648,91.184S130.472,99.3,127.541,106.3Z",
    transform: "translate(-5.732 -35.832)",
    fill: "#4f85e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M137.648,91.184S130.472,99.3,127.541,106.3",
    transform: "translate(-5.732 -35.832)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M137.759,130.48s8.519-9.833,9.869-20.839",
    transform: "translate(-4.823 -34.191)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M133.571,124.039l3.72-3.293s1.59,5.824,1.35,7.613-1.289,1.219-1.775.841-3.99-4.528-3.99-4.528l.7-.624Z",
    transform: "translate(-5.258 -33.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M171.263,99.071a27.057,27.057,0,0,0-1.227-7.157c-.857-5.152-11.659-23.808-18.257-34.659-13.619-22.389-26.035-15.132-26.035-15.132-2.986,1.327-4.391,4.288-2.716,6.717,0,0,3.056,6.332,7.57,6.525.27.015.54.015.818.023a17.93,17.93,0,0,1,4.5,9.209c.27,1.92.448,3.764.625,5.468a67.292,67.292,0,0,0,1.142,11.144s1.6,10.466,5.756,13.15,9.291,4.311,11.243,9.6,17.083,7.211,16.6-4.905Z",
    transform: "translate(-6.197 -40.295)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M135.725,59.79s2.732-2.021,4.328.308-1.126,3.8-2.531,4.519-1.79-4.836-1.79-4.836Z",
    transform: "translate(-5.004 -38.696)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M136.985,63.156a6.51,6.51,0,0,0-1.373,3.548c.008,1.851,1.358,4.211,3.287,2.761s.355-3.987-.054-4.843-.748-2.028-1.86-1.473Z",
    transform: "translate(-5.014 -38.338)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M120.913,62.57A5.174,5.174,0,0,0,119.9,65.2c0,1.3,1.481.91,1.481.91",
    transform: "translate(-6.411 -38.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M120.913,62.57A5.174,5.174,0,0,0,119.9,65.2c0,1.3,1.481.91,1.481.91",
    transform: "translate(-6.411 -38.377)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M121.99,150.542l-1.127,5.654s-3.094-2.391-3.171-2.885S118.124,151.214,121.99,150.542Z",
    transform: "translate(-6.608 -30.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M138.51,59.844l-1.467,2.414",
    transform: "translate(-4.887 -38.619)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M138.621,61.41l-1.018-.27",
    transform: "translate(-4.837 -38.504)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M169.864,150.082s4.091,26.176,2.76,40.9,2.358,28.409,1.824,27.577",
    transform: "translate(-5.368 -30.595)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M122.3,150.542s-8.4,37.578-7.784,67.579",
    transform: "translate(-6.917 -30.554)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M113.624,60.648s2.546-1.5,3.556-.478a2.718,2.718,0,0,1,.548,2.53S114.873,62.214,113.624,60.648Z",
    transform: "translate(-6.969 -38.622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M123.162,60.921s1.605-2.391,3.556-.926c1.15.864.548,2.53.548,2.53S124.412,62.479,123.162,60.921Z",
    transform: "translate(-6.121 -38.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M66.692,88.891l9.445,47.57a4.543,4.543,0,0,1-2.323,4.889L55.758,151.769a4.547,4.547,0,0,1-6.574-3.015L36.428,92.207A4.55,4.55,0,0,1,40.256,86.7l21.366-1.435A4.549,4.549,0,0,1,66.7,88.891Z",
    transform: "translate(-13.844 -36.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M69.555,88.268,79,135.837a4.544,4.544,0,0,1-2.323,4.89L58.621,151.146a4.548,4.548,0,0,1-6.574-3.015L39.291,91.584a4.55,4.55,0,0,1,3.827-5.507l21.366-1.435a4.549,4.549,0,0,1,5.077,3.625Z",
    transform: "translate(-13.589 -36.418)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M45.947,95.1l23.365-2.753a1.568,1.568,0,0,1,1.844,1.265l.494,4.172c.139.8-.093,1.165-.88,1.373l-23.157,4.35a1.568,1.568,0,0,1-1.937-1.234l-.964-5.361A1.562,1.562,0,0,1,45.955,95.1Z",
    transform: "translate(-13.1 -35.731)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M47.171,94.777l23.342-2.861a1.566,1.566,0,0,1,1.86,1.242l.795,4.4a1.562,1.562,0,0,1-1.119,1.8l-23.095,3.818A1.57,1.57,0,0,1,47,101.958l-1.034-5.353a1.564,1.564,0,0,1,1.219-1.828Z",
    transform: "translate(-12.988 -35.77)",
    fill: "#fff",
    stroke: "#4f85e2",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M47.853,104.94l23.458-4.156a1.568,1.568,0,0,1,1.844,1.264l.4,4.018c.139.8-.093,1.165-.88,1.373L49.52,113.354a1.567,1.567,0,0,1-1.937-1.234l-.965-5.36a1.563,1.563,0,0,1,1.242-1.813Z",
    transform: "translate(-12.93 -34.981)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M49.078,104.624l23.095-4.272a1.566,1.566,0,0,1,1.86,1.241l.8,4a1.561,1.561,0,0,1-1.119,1.8l-22.863,5.614A1.569,1.569,0,0,1,48.9,111.8l-1.034-5.352a1.564,1.564,0,0,1,1.219-1.828Z",
    transform: "translate(-12.819 -35.02)",
    fill: "#4f85e2",
    stroke: "#4f85e2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M50.433,114.842l22.254-5.722a1.568,1.568,0,0,1,1.844,1.264l.633,4.1c.139.8-.093,1.164-.88,1.373l-22.184,7.4a1.568,1.568,0,0,1-1.937-1.234l-.965-5.361a1.562,1.562,0,0,1,1.242-1.812Z",
    transform: "translate(-12.701 -34.24)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M51.657,114.525l22.231-5.83a1.566,1.566,0,0,1,1.86,1.241l.695,4.08a1.562,1.562,0,0,1-1.119,1.8l-21.891,7.1a1.569,1.569,0,0,1-1.952-1.211l-1.034-5.352a1.564,1.564,0,0,1,1.219-1.828Z",
    transform: "translate(-12.59 -34.278)",
    fill: "#fff",
    stroke: "#4f85e2",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M53.011,124.822l21.5-7.3a1.568,1.568,0,0,1,1.844,1.264l.532,3.926c.139.8-.093,1.165-.88,1.373l-21.32,9.139a1.567,1.567,0,0,1-1.937-1.235l-.965-5.36a1.561,1.561,0,0,1,1.242-1.812Z",
    transform: "translate(-12.471 -33.492)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M54.236,124.505l21.112-7.4a1.566,1.566,0,0,1,1.86,1.241l.949,3.918a1.562,1.562,0,0,1-1.119,1.8L56.011,132.9a1.57,1.57,0,0,1-1.952-1.211l-1.034-5.353a1.563,1.563,0,0,1,1.219-1.827Z",
    transform: "translate(-12.361 -33.531)",
    fill: "#fff",
    stroke: "#4f85e2",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M78.3,70.863l-2.479,1.051a1.565,1.565,0,0,0-.831,2.053l1.051,2.478a1.567,1.567,0,0,0,2.054.83l2.479-1.051a1.565,1.565,0,0,0,.831-2.053l-1.051-2.478A1.567,1.567,0,0,0,78.3,70.863Z",
    transform: "translate(-10.416 -37.65)",
    fill: "#4069e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M95.738,135.747,93.258,136.8a1.565,1.565,0,0,0-.831,2.053l1.051,2.478a1.567,1.567,0,0,0,2.054.83l2.479-1.051a1.565,1.565,0,0,0,.831-2.053l-1.051-2.478A1.567,1.567,0,0,0,95.738,135.747Z",
    transform: "translate(-8.865 -31.881)",
    fill: "#f0c103"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M102.483,87.06l-.409-.177a.337.337,0,0,1-.177-.447l.177-.409a.331.331,0,0,0-.177-.447l-.886-.378a.331.331,0,0,0-.448.177l-.177.409a.337.337,0,0,1-.448.177l-.409-.177a.331.331,0,0,0-.448.177l-.378.887a.331.331,0,0,0,.177.447l.409.177a.336.336,0,0,1,.178.447l-.178.409a.331.331,0,0,0,.178.447l.887.378a.331.331,0,0,0,.448-.177l.178-.409a.336.336,0,0,1,.448-.177l.409.177a.331.331,0,0,0,.448-.177l.378-.887A.331.331,0,0,0,102.483,87.06Z",
    transform: "translate(-8.299 -36.367)",
    fill: "#b580d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M67.131,154.946l-.409-.178a.336.336,0,0,1-.177-.448l.177-.408a.331.331,0,0,0-.177-.448l-.887-.378a.331.331,0,0,0-.448.177l-.177.408a.336.336,0,0,1-.448.177l-.409-.177a.331.331,0,0,0-.448.177l-.378.887a.33.33,0,0,0,.177.446l.409.177a.336.336,0,0,1,.177.448l-.177.409a.33.33,0,0,0,.177.446l.887.378a.331.331,0,0,0,.448-.178l.177-.408a.336.336,0,0,1,.448-.177l.409.177a.331.331,0,0,0,.448-.177l.378-.886A.331.331,0,0,0,67.131,154.946Z",
    transform: "translate(-11.443 -30.33)",
    fill: "#f48639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M154.461,153.142s3.665,21.825,2.932,36.857-.9,17.146,2.961,27.773",
    transform: "translate(-3.338 -30.323)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M107.848,182.706a6.769,6.769,0,0,0,5.71.37c3.558-1.126,4.808-2.314,4.668-3.131s-3.033-.2-4.19-.077a20.146,20.146,0,0,1-3.873-.393",
    transform: "translate(-7.483 -27.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M107.848,182.706a6.769,6.769,0,0,0,5.71.37c3.558-1.126,4.808-2.314,4.668-3.131s-3.033-.2-4.19-.077a20.146,20.146,0,0,1-3.873-.393",
    transform: "translate(-7.483 -27.981)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M117.494,179.87s1.119-2.275.572-2.838-6.675.293-6.675.293",
    transform: "translate(-7.168 -28.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M117.494,179.87s1.119-2.275.572-2.838-6.675.293-6.675.293",
    transform: "translate(-7.168 -28.215)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M121.986,155.734s-7.986,12.872-8.117,14.384.74,4.658-.849,7.365-5.973,9.355-7.045,9.447-1.049-1.381-.988-3.117a52.05,52.05,0,0,1,.749-5.375",
    transform: "translate(-7.74 -30.092)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M119.061,129.422c-4.877,27.433-16.066,39.318-16.845,49.259-.177,2.229.848,3.44,3.21,5.607",
    transform: "translate(-7.986 -32.432)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M112.972,174.314a2.543,2.543,0,0,0,2.476-.015c1.374-.857,2.732-.98,2.33.609s-1.866,1.813-3.758,2.376",
    transform: "translate(-7.027 -28.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M112.972,174.314a2.543,2.543,0,0,0,2.476-.015c1.374-.857,2.732-.98,2.33.609s-1.866,1.813-3.758,2.376",
    transform: "translate(-7.027 -28.497)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M73.82,99.295l4.113-5.136",
    transform: "translate(-10.509 -35.568)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M73.82,106.284l3.341,8.885",
    transform: "translate(-10.509 -34.49)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M74.954,100.406l11.459-4.265",
    transform: "translate(-10.408 -35.391)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M71.964,99.119l1.111-13.736",
    transform: "translate(-10.674 -36.348)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M74.954,104.938l7.246,6",
    transform: "translate(-10.408 -34.609)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.94631613.svg";
export { ForwardRef as ReactComponent };